import { computed } from '@vue/composition-api'
import store from '@/store'
import { UPDATE_PRODUCT_INFO } from '@/store/modules/productEdit.module'

export const useAdditionalInfo = () => {
  const country = computed({
    get() {
      return store.state.productEdit.newData.country
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'country', newValue: value })
    },
  })
  const hscode = computed({
    get() {
      return store.state.productEdit.newData.hscode
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'hscode', newValue: value })
    },
  })
  const lines = computed({
    get() {
      return store.state.productEdit.newData.lines
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'lines', newValue: value })
    },
  })
  const subLines = computed({
    get() {
      return store.state.productEdit.newData.subLines
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'subLines', newValue: value })
    },
  })
  const groups = computed({
    get() {
      return store.state.productEdit.newData.groups
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'groups', newValue: value })
    },
  })
  const subGroups = computed({
    get() {
      return store.state.productEdit.newData.subGroups
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'subGroups', newValue: value })
    },
  })
  const orderIndex = computed({
    get() {
      return store.state.productEdit.newData.orderIndex
    },
    set(value) {
      const newValue = value === '' ? undefined : Number(value)
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'orderIndex', newValue })
    },
  })
  const shippingStartDate = computed({
    get() {
      return store.state.productEdit.newData.shippingStartDate
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'shippingStartDate', newValue: value })
    },
  })
  const shippingEndDate = computed({
    get() {
      return store.state.productEdit.newData.shippingEndDate
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'shippingEndDate', newValue: value })
    },
  })
  const keywords = computed({
    get() {
      return store.state.productEdit.newData.keywords
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'keywords', newValue: value })
    },
  })
  const recommendedItems = computed({
    get() {
      return store.state.productEdit.newData.recommendedItems
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'recommendedItems', newValue: value })
    },
  })
  const keyStyles = computed({
    get() {
      return store.state.productEdit.newData.keyStyles
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'keyStyles', newValue: value })
    },
  })
  return {
    country,
    hscode,
    lines,
    subLines,
    groups,
    subGroups,
    orderIndex,
    shippingStartDate,
    shippingEndDate,
    keywords,
    recommendedItems,
    keyStyles,
  }
}
